import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyProjectMembersProjectState } from './projectMembers.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerProjectMembers = (
  state: AppState,
  projectId: number | null,
) => {
  if (projectId == null) return createEmptyProjectMembersProjectState()
  return (
    state.taskTracker.projectMembers.byProjectId[projectId] ??
    createEmptyProjectMembersProjectState()
  )
}
